'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-half-stroke';
var width = 512;
var height = 512;
var aliases = [9680,"adjust"];
var unicode = 'f042';
var svgPathData = ['M16 256c0 129.9 103.2 235.6 232 239.9l0-479.7C119.2 20.4 16 126.1 16 256z', 'M264 495.9c128.8-4.2 232-110 232-239.9S392.8 20.4 264 16.1l0 479.7zm-16 0l0-479.7C119.2 20.4 16 126.1 16 256s103.2 235.6 232 239.9zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;